import ContactListBase from "./ContactListBase";


export default function ClientList() {
    return <ContactListBase title="Clientes" endpoint="contacts/" defaultType="CLIENT" />;
}